import { Loader } from "@utp/react-components-prod";

interface LoadingPageProps {
  isLoading: boolean;
}

const LoadingPage = ({ isLoading }: LoadingPageProps) => {
  return (
    <div
      className={`absolute top-0 w-full h-full bg-transparent-load items-center justify-center flex-col z-10 left-0 ${
        isLoading ? "flex" : "hidden"
      }`}
      data-testid="loading-page"
    >
      <div className="bg-white rounded-lg p-3">
        <Loader size={30} className="" />
      </div>
      <p className="mt-5 text-white font-bold">Cargando...</p>
    </div>
  );
};

export default LoadingPage;
